import axios from 'axios';
import { API_URL } from 'config/URL/URL';

const DEFAULT_SRS = 'EPSG:3857';

const fetchJson = async (url, params) => {
    const { data } = await axios.get(url, { params });
    return data;
};

export const buildPopulationInfoUrl = ({ extent, age, layerName }) => {
    const extentParam = extent?.length === 4 ? extent.join(',') : undefined;
    return `${API_URL}/pop/getInfo?age=${age ?? 'all'}&extent=${extentParam}&srsname=${DEFAULT_SRS}&layerName=${layerName}&outputFormat=application/json`;
};

export const fetchPopulationInfo = ({ extent, age, layerName }) =>
    fetchJson(buildPopulationInfoUrl({ extent, age, layerName }));

export const fetchPopulationRouteInfo = ({ layerName, hjdCd, count, direction, age, houseType, type }) => {
    const endpoint = type?.indexOf('pop') > -1 ? 'getInfoRoute' : 'getInfoRouteHouseHold';
    return fetchJson(`${API_URL}/pop/${endpoint}`, {
        layerName,
        hCd: hjdCd,
        cnt: count,
        direction,
        age,
        houseType,
    });
};

export const fetchPopulationCategories = () => fetchJson(`${API_URL}/pop/category`);
